



































import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'

@Component
export default class AppSimpleTextField extends Vue {
  @Prop(String) readonly value!: string;
  @Prop(String) readonly label!: string;
  @Prop({ type: String }) readonly placeholder!: string;
  @Prop({ type: [Number, String], default: '289' }) readonly width!:
    | number
    | string;

  @Prop({ type: [Number, String], default: 36 }) readonly height!:
    | number
    | string;

  @Prop({ type: String }) readonly prefix!: string;
  @Prop({ type: String }) readonly suffix!: string;
  @Prop({ type: String }) readonly prefixOut!: string;
  @Prop({ type: String }) readonly suffixOut!: string;

  model = '';

  mounted () {
    this.model = this.value
  }

  @Watch('value')
  onValueChanged (val: string) {
    this.model = val ? this.$R.trim(val) : ''
  }

  @Emit('input')
  valueChangedHandler (val: string) {
    this.model = val
    if (!val) {
      return ''
    }
    return this.$R.trim(val)
  }
}
